var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pre',{staticClass:"text-left"},[_vm._v(_vm._s(_vm._f("pretty")(_vm.courseTemplate)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }